import { ReactNode, FC } from 'react';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';

export interface BaseIconButtonProps extends IconButtonProps {
    children: ReactNode;
    className?: string;
    disabled?: boolean; // Add the disabled prop
}

const BaseIconButton: FC<BaseIconButtonProps> = ({
    onClick,
    children,
    className,
    disabled = false, // Default to false
    ...props
}) => {
    return (
        <IconButton
            onClick={onClick}
            className={className}
            disabled={disabled} // Pass the disabled prop to the MUI IconButton
            {...props}
        >
            {children}
        </IconButton>
    );
};

export default BaseIconButton;
